
import { createAction, ActionsUnion, ActionWithPayload } from "../utils/utils";

// ACTIONS TYPES
export enum EditActionsEnum {
  UPDATE_OBJECT = "Update object (saga)",
  ADD_ACTION = "Add standard Action (saga)",
  ADD_OBJECT = "Add object (saga)",
  ADD_NODE = "Add node with parent id (saga)",
  ADD_TRANSLATIONS = "Add translations (saga)",
  UPDATE_PARAMETERS = "Update several objects (saga)",
  UPDATE_ESCALATOR_BINDINGS = "Update bindings for escalator (saga)",
  UPDATE_ESCALATOR_FAULT_BINDINGS = "Update fault bindings for escalator (saga)",
  UPDATE_BINDINGS = "Update bindings (saga)",
  UPDATE_LIFT_BINDINGS = "Update bindings for lift (saga)",
  DELETE_OBJECT = "Delete object that is open in editView (saga)",
  DELETE_BY_ID = "Delete object by id and option (saga)",
  START_EDITING_OBJECT = "Start editing object (saga)",
  CANCEL_EDITING_OBJECT = "Cancel editing object (saga)",
  SELECT_OBJECT = "Select object (saga)",
  SELECT_PARENT = "Select parent object (saga)",

  SET_EDITED_OBJECT = "Set edited object",
  SET_STORED_OBJECT = "Set stored object before editing",
  SET_PARENT_OBJECT = "Set parent object",
  SET_EDITED_OBJECT_TYPE = "Set edited object type",

  TOGGLE_CHILD_VIEW = "Toggle child view",
  COPY_OBJECT = "Copy objects to clipboard",
  PASTE_OBJECT = "Paste objects from clipboard",
  CLEAR_HAS_EDITED = "Clear hasEdited flag"
}

// ACTION CREATORS
export const editActions = {
  update: (
    option: Api.OptionsGrud
  ): ActionWithPayload<EditActionsEnum.UPDATE_OBJECT, Api.OptionsGrud> =>
    createAction(EditActionsEnum.UPDATE_OBJECT, option),
  addAction: (
    parentPointId: string,
    actionType: "ionodePointActions" | "standardActions"
  ): ActionWithPayload<
    EditActionsEnum.ADD_ACTION,
    { parentPointId: string; actionType: "standardActions" | "ionodePointActions" }
  > => createAction(EditActionsEnum.ADD_ACTION, { parentPointId, actionType }),
  addNode: (parentId: string): ActionWithPayload<EditActionsEnum.ADD_NODE, string> =>
    createAction(EditActionsEnum.ADD_NODE, parentId),
  addTranslations: (
    translations: ArrayBuffer
  ): ActionWithPayload<EditActionsEnum.ADD_TRANSLATIONS, ArrayBuffer> =>
    createAction(EditActionsEnum.ADD_TRANSLATIONS, translations),
  updateParameters: (
    parameterType: Api.GroupName,
    parameters: Api.DriveParameter[] | Api.LiftParameter[]
  ): ActionWithPayload<
    EditActionsEnum.UPDATE_PARAMETERS,
    { parameterType: Api.GroupName; parameters: Api.DriveParameter[] | Api.LiftParameter[] }
  > => createAction(EditActionsEnum.UPDATE_PARAMETERS, { parameterType, parameters }),
  updateEscalatorBindings: (
    operation: string,
    escalatorBulkBindings: Api.EscalatorBulkBindings
  ): ActionWithPayload<
    EditActionsEnum.UPDATE_ESCALATOR_BINDINGS,
    {operation: string; escalatorBulkBindings: Api.EscalatorBulkBindings }
  > => createAction(EditActionsEnum.UPDATE_ESCALATOR_BINDINGS, { operation, escalatorBulkBindings }),
  updateEscalatorFaultBindings: (
    operation: string,
    escalatorFaultBulkBindings: Api.EscalatorFaultBulkBindings
  ): ActionWithPayload<
    EditActionsEnum.UPDATE_ESCALATOR_FAULT_BINDINGS,
    { operation: string; escalatorFaultBulkBindings: Api.EscalatorFaultBulkBindings }
  > => createAction(EditActionsEnum.UPDATE_ESCALATOR_FAULT_BINDINGS, { operation, escalatorFaultBulkBindings }),
  updateDoorBindings: (
    parameterType: string,
    parameters: Api.DoorBindings
  ): ActionWithPayload<
    EditActionsEnum.UPDATE_BINDINGS,
    { parameterType: string; parameters: Api.DoorBindings }
  > => createAction(EditActionsEnum.UPDATE_BINDINGS, { parameterType, parameters }),
  updateLiftBindings: (
    operation: "Add" | "Remove",
    liftBulkBindings: Api.LiftBulkBindings
  ): ActionWithPayload<
    EditActionsEnum.UPDATE_LIFT_BINDINGS,
    { operation: "Add" | "Remove"; liftBulkBindings: Api.LiftBulkBindings }
  > => createAction(EditActionsEnum.UPDATE_LIFT_BINDINGS, { operation, liftBulkBindings }),
  add: (option: Api.OptionsGrud): ActionWithPayload<EditActionsEnum.ADD_OBJECT, Api.OptionsGrud> =>
    createAction(EditActionsEnum.ADD_OBJECT, option),
  delete: (
    option: Api.OptionsGrud
  ): ActionWithPayload<EditActionsEnum.DELETE_OBJECT, Api.OptionsGrud> =>
    createAction(EditActionsEnum.DELETE_OBJECT, option),
  deleteById: (
    option: Api.OptionsGrud,
    id: string
  ): ActionWithPayload<EditActionsEnum.DELETE_BY_ID, { option: Api.OptionsGrud; id: string }> =>
    createAction(EditActionsEnum.DELETE_BY_ID, { option, id }),
  startEditing: (
    object: Api.AnyItem,
    isNew = false
  ): ActionWithPayload<
    EditActionsEnum.START_EDITING_OBJECT,
    { object: Api.AnyItem; isNew: boolean }
  > => createAction(EditActionsEnum.START_EDITING_OBJECT, { object, isNew }),
  cancelEditing: (): Api.AnyItem => createAction(EditActionsEnum.CANCEL_EDITING_OBJECT),
  select: (
    object: Api.AnyItem
  ): ActionWithPayload<EditActionsEnum.SELECT_OBJECT, { object: Api.AnyItem }> =>
    createAction(EditActionsEnum.SELECT_OBJECT, object),
  selectParent: (
    object: Api.AnyItem
  ): ActionWithPayload<EditActionsEnum.SELECT_PARENT, { object: Api.AnyItem }> =>
    createAction(EditActionsEnum.SELECT_PARENT, object),
  setEdited: (
    object: Api.AnyItem | undefined
  ): ActionWithPayload<EditActionsEnum.SET_EDITED_OBJECT, { object: Api.AnyItem }> =>
    createAction(EditActionsEnum.SET_EDITED_OBJECT, object),
  setStored: (
    object: Api.AnyItem | undefined
  ): ActionWithPayload<EditActionsEnum.SET_STORED_OBJECT, { object: Api.AnyItem | undefined }> =>
    createAction(EditActionsEnum.SET_STORED_OBJECT, object),
  setParent: (
    object: Api.AnyItem | undefined
  ): ActionWithPayload<EditActionsEnum.SET_PARENT_OBJECT, { object: Api.AnyItem | undefined }> =>
    createAction(EditActionsEnum.SET_PARENT_OBJECT, object),
  setEditedType: (
    itemeTypeName: string
  ): ActionWithPayload<EditActionsEnum.SET_EDITED_OBJECT_TYPE,  string> =>
    createAction(EditActionsEnum.SET_EDITED_OBJECT_TYPE,  itemeTypeName ),

  toggleChildView: (): Api.AnyItem => createAction(EditActionsEnum.TOGGLE_CHILD_VIEW),
  copyObject: (
    object: State.ClipBoard
  ): ActionWithPayload<EditActionsEnum.COPY_OBJECT, State.ClipBoard> =>
    createAction(EditActionsEnum.COPY_OBJECT, object),
  pasteObject: (): Api.AnyItem => createAction(EditActionsEnum.PASTE_OBJECT),
  clearHasEdited: (): Api.AnyItem => createAction(EditActionsEnum.CLEAR_HAS_EDITED)
};

export type EditActions = ActionsUnion<typeof editActions>;
